module.exports = __WEBPACK_EXTERNAL_MODULE_isomorphic_fetch__;